"use client";

import { useTranslations } from "use-intl";

import { GlobeIcon } from "@/components/appIcons";
import { FilterSelect, type FilterOption } from "@/components/ui/filter-select";

interface CountryFilterSelectProps {
  options: FilterOption[];
  value: string | null;
  onChange: (value: string | null) => void;
  placeholder?: string;
}

export function CountryFilterSelect({
  options,
  value,
  onChange,
  placeholder,
}: CountryFilterSelectProps) {
  const t = useTranslations("shared.releaseFilters");

  return (
    <FilterSelect
      icon={GlobeIcon}
      placeholder={placeholder ?? t("country")}
      options={options}
      value={value}
      onChange={onChange}
      searchable
      searchPlaceholder={t("searchCountry")}
    />
  );
}
